import { render, staticRenderFns } from "./mapsideswitch.vue?vue&type=template&id=45a336ea"
import script from "./mapsideswitch.vue?vue&type=script&lang=js"
export * from "./mapsideswitch.vue?vue&type=script&lang=js"
import style0 from "./mapsideswitch.vue?vue&type=style&index=0&id=45a336ea&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports